export const convertAmountToAmountUnit = (
  amount: number,
  amountUnitId: number,
  kgOnNonWeightMeasureUnit: number
): number => {
  switch (amountUnitId) {
    case 1: // Kg
      return Number(amount.toFixed(2));
    case 2: // Tons
      return Number((amount / 1000).toFixed(3));
    case 3: // Stk / pieces
      if (kgOnNonWeightMeasureUnit === 0) return 0;
      return Number(kgOnNonWeightMeasureUnit.toFixed(2));
    case 4: // M3
      if (kgOnNonWeightMeasureUnit === 0) return 0;
      return Number(kgOnNonWeightMeasureUnit.toFixed(2));
    case 5: // Meters
      if (kgOnNonWeightMeasureUnit === 0) return 0;
      return Number(kgOnNonWeightMeasureUnit.toFixed(2));
    default:
      return Number(amount.toFixed(2));
  }
};
